import Select from 'react-select';
/**
 * WordPress dependencies
 */
const { useState } = wp.element;
const { useSelect } = wp.data;

const EDDProductCategorySelect = (props) => {
	const [searchKeyword, setSearchKeyword] = useState('');

	const { data, isRequesting } = useSelect(
		(select) => {
			const { isResolving } = select('core/data');

			const params = {
				per_page: 8,
				search: searchKeyword
			};

			return {
				data: select('core').getEntityRecords('taxonomy', 'download_category', params),
				isRequesting: isResolving('core', 'getEntityRecords', ['taxonomy', 'download_category', params])
			};
		},
		[searchKeyword]
	);

	const options =
		data?.map((term) => ({
			label: `${term.name} (ID: ${term.id})`,
			value: term.id
		})) || [];

	return (
		<div>
			<Select
				classNamePrefix='conditional-blocks-select'
				className='conditional-blocks-select-container'
				isSearchable
				isLoading={isRequesting}
				options={options}
				onInputChange={(val) => setSearchKeyword(val)}
				{...props}
			/>
		</div>
	);
};

export default EDDProductCategorySelect;
